import { createContext } from "react"
export const SiteLocation = createContext("/fr")
